import * as React from 'react';
import { useSelector } from 'react-redux';
import { EmptyResultTitle } from '../../components/EmptyResultTitle';
import { selectGeoPath } from '../../selectors/location/selectGeoPath';

export const EmptySearchResult = () => {
  const geoPath = useSelector(selectGeoPath);

  const handleClick = React.useCallback(() => {
    const basePath = geoPath ? `/${geoPath}/novostroyki/` : '/novostroyki/';
    window.location.href = basePath;
  }, [geoPath]);

  return <EmptyResultTitle onClick={handleClick} />;
};
